import React from 'react';
import { Helmet } from 'react-helmet-async';
import CrmSoftware from '../components/CrmSoftware';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://wayug.com/' },
    { '@type': 'ListItem', position: 2, name: 'CRM Software', item: 'https://wayug.com/crm-software' },
  ],
};

const softwareSchema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Wayug Custom Sales & WhatsApp CRM',
  operatingSystem: 'Web, Windows, Android, iOS',
  applicationCategory: 'BusinessApplication',
  offers: {
    '@type': 'Offer',
    price: '80000',
    priceCurrency: 'INR',
  },
  description: 'Custom CRM software for small businesses in India & Delhi NCR. WhatsApp automation, IndiaMart lead capture, GST billing, and Tally sync.',
  author: {
    '@type': 'Organization',
    name: 'Wayug Infotech Solutions',
    url: 'https://wayug.com',
  },
};

export default function CrmSoftwarePage() {
  return (
    <div className="page-content subpage-content">
      <Helmet>
        <title>CRM Software for Small Business India | WhatsApp &amp; GST Sync – Wayug</title>
        <meta
          name="description"
          content="Custom CRM software for Indian businesses. WhatsApp API automation, IndiaMart lead integration, GST quotation generator &amp; Tally sync. Book a demo today."
        />
        <link rel="canonical" href="https://wayug.com/crm-software" />
        <meta property="og:title" content="CRM Software for Small Business India | Wayug Infotech" />
        <meta
          property="og:description"
          content="Accelerate sales with customized CRM software built for Indian SMEs. Capture IndiaMart leads instantly, automate WhatsApp follow-ups, and send GST quotes."
        />
        <meta property="og:url" content="https://wayug.com/crm-software" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(softwareSchema)}</script>
      </Helmet>
      <CrmSoftware />
    </div>
  );
}
